export var prototimeToDate = function (_a) {
    var seconds = _a.seconds, nanos = _a.nanos;
    return new Date(Number(seconds) * 1000 + nanos / 1000000);
};
